export enum UserEntityTypeEnum {
  ADMIN_ID,
  USER_ID,
  PARTNER_ID,
}
